import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SiteOverview from './pages/SiteOverview';
import ReportsLibrary from './pages/ReportsLibrary';
import TestingLibrary from './pages/TestingLibrary';
import DocumentsLibrary from './pages/DocumentsLibrary';
import SettingsDatabase from './pages/SettingsDatabase';
import PendingChanges from './pages/PendingChanges';
import SubstationDetail from './pages/SubstationDetail';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem('prot_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>{children}</ProtectedRoute>
);

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Dashboard */}
        <Route path="/" element={<P><Dashboard /></P>} />

        {/* Site hub */}
        <Route path="/site/:siteId" element={<P><SiteOverview /></P>} />
        <Route path="/site/:siteId/reports" element={<P><ReportsLibrary /></P>} />
        <Route path="/site/:siteId/testing" element={<P><TestingLibrary /></P>} />
        <Route path="/site/:siteId/documents" element={<P><DocumentsLibrary /></P>} />
        <Route path="/site/:siteId/settings" element={<P><SettingsDatabase /></P>} />
        <Route path="/site/:siteId/changes" element={<P><PendingChanges /></P>} />

        {/* Deep drill-down (existing) */}
        <Route path="/substation/:subId" element={<P><SubstationDetail /></P>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
